import type { AuthContextType } from '@context/auth.context';
import type { TelegramMenuItem } from '@interfaces/telegram-menu-item';
import { apiRequest, isResponse } from '@services/fetcher';
import type { LoaderFunction } from 'react-router-dom';

interface MenuItemsResult {
  data: TelegramMenuItem[];
  meta: {
    isDraft: boolean;
  };
}

export const loader = (auth: AuthContextType) =>
  (async ({ request }) => {
    const response = await apiRequest<MenuItemsResult>(`${import.meta.env.VITE_API_URL}/manage/telegram-menu`, auth, {
      signal: request.signal,
    });

    if (isResponse(response)) {
      return {
        status: response.status,
        statusText: response.statusText,
      } as Response;
    }

    if (response instanceof Error) {
      throw response;
    }

    return response;
  }) satisfies LoaderFunction;
